export const ROUTE_TRANSACCIONES_CONVENIO = 'convenios:transacciones:convenio'

export const ROUTE_TRANSACCIONES_GESTION_CONVENIO = 'convenios:transacciones:gestion-convenio'

export const ROUTE_TRANSACCIONES_APROBACION_CONVENIO = 'convenios:transacciones:aprobacion-convenio'
